/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'jira-project-term-refresh-changeboarding-flag': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--jira-project-term-refresh-changeboarding-flag/placements/in-app/screen-space-flags/render'
			),
	),
	'ptr-changeboarding-space-navigation-spotlight': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--ptr-changeboarding-space-navigation-spotlight/placements/in-app/screen-space-flags/render'
			),
	),
};
